import $ from 'jquery';
import Masonry from 'masonry-layout';
import '../../../../node_modules/slick-carousel/slick/slick.scss';
import 'slick-carousel';
import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';

class TeaserContainer {
    constructor(elem) {
        this.elem = elem;
        this.breakpoints = {
            'screen-xs': 576,
            'screen-sm': 768,
            'screen-md': 992,
        };
    }

    init() {
        if (this.elem.classList.contains('teaser-container--slider-mobile')) {
            this.initMobileSlider();
        }

        if (this.elem.classList.contains('teaser-container--masonry')) {
            this.initMasonryLayout();
        }
    }

    initMasonryLayout() {
        const masonry = new Masonry(this.elem, {
            itemSelector: '.teaser',
        });
        document.addEventListener('lazyloaded', (event) => {
            if (this.elem.contains(event.target)) {
                masonry.layout();
            }
        });
    }

    initMobileSlider() {
        const buttonNextText = this.elem.getAttribute('data-slider-button-next') || 'Next';
        const buttonPrevText = this.elem.getAttribute('data-slider-button-prev') || 'Previous';

        const prevArrow = `<button class="slick-prev slick-arrow" type="button">${buttonPrevText}</button>`;
        const nextArrow = `<button class="slick-next slick-arrow" type="button">${buttonNextText}</button>`;

        const settings = {
            accessibility: true,
            dots: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            prevArrow,
            nextArrow,
            responsive: [
                {
                    breakpoint: this.breakpoints['screen-xs'] - 1, // https://github.com/kenwheeler/slick/issues/2503
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: this.breakpoints['screen-sm'] - 1, // https://github.com/kenwheeler/slick/issues/2503
                    settings: 'unslick',
                },
            ],
        };
        $(this.elem).slick(settings);

        window.addEventListener('resize', GeneralHelper.throttle((e) => {
            if (!this.elem.classList.contains('slick-initialized')
                && $(e.currentTarget).width() < this.breakpoints['screen-sm']) {
                $(this.elem).slick(settings);
            }
        }, 200));
    }
}

export default TeaserContainer;
